'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true,
})
exports.Button = void 0

var _clsx = _interopRequireDefault(require('clsx'))

var _react = _interopRequireDefault(require('react'))

var _reactRouterDom = require('react-router-dom')

var _styledComponents = _interopRequireDefault(require('styled-components'))

var _index = require('../Spinner/index.js')

var _styles = require('./styles.js')

var _templateObject, _templateObject2

var _excluded = [
  'to',
  'Icon',
  'loading',
  'iconPosition',
  'iconSpacing',
  'color',
  'margin',
  'type',
  'children',
  'isDashed',
  'className',
]

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0)
  }
  return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }))
}

function _extends() {
  _extends =
    Object.assign ||
    function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i]
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key]
          }
        }
      }
      return target
    }
  return _extends.apply(this, arguments)
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {}
  var target = _objectWithoutPropertiesLoose(source, excluded)
  var key, i
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source)
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i]
      if (excluded.indexOf(key) >= 0) continue
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue
      target[key] = source[key]
    }
  }
  return target
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {}
  var target = {}
  var sourceKeys = Object.keys(source)
  var key, i
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i]
    if (excluded.indexOf(key) >= 0) continue
    target[key] = source[key]
  }
  return target
}

var Button = function Button(_ref) {
  var to = _ref.to,
    Icon = _ref.Icon,
    loading = _ref.loading,
    _ref$iconPosition = _ref.iconPosition,
    iconPosition = _ref$iconPosition === void 0 ? 'left' : _ref$iconPosition,
    _ref$iconSpacing = _ref.iconSpacing,
    iconSpacing = _ref$iconSpacing === void 0 ? 'center' : _ref$iconSpacing,
    color = _ref.color,
    margin = _ref.margin,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'submit' : _ref$type,
    children = _ref.children,
    isDashed = _ref.isDashed,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded)

  return /*#__PURE__*/ _react['default'].createElement(
    _styles.StyledButton,
    _extends(
      {
        Icon: Icon,
        color: color,
        margin: margin,
        iconPosition: iconPosition,
        iconSpacing: iconSpacing,
        type: type,
        className: (0, _clsx['default'])(
          className,
          isDashed ? 'border-dashed border-4' : 'border',
          'inline-flex justify-center items-center space-x-2 rounded font-semibold focus:outline-none px-3 py-2 leading-6 ',
          props.variant === 'filled' &&
            !props.disabled &&
            'green-700 bg-green-700 text-white hover:text-white hover:bg-green-800 hover:border-green-800 focus:ring focus:ring-green-500 focus:ring-opacity-50 active:bg-green-700',
          (props.variant === 'default' || !props.variant) &&
            'border-gray-300 bg-white text-gray-800 shadow-sm hover:text-gray-800 hover:bg-gray-100 hover:border-gray-300 hover:shadow focus:ring focus:ring-gray-500 focus:ring-opacity-25 active:bg-white active:border-white active:shadow-none',
          props.variant === 'secondary' &&
            'border-green-200 bg-green-200 text-green-700 hover:text-green-700 hover:bg-green-300 hover:border-green-300 focus:ring focus:ring-green-500 focus:ring-opacity-50 active:bg-green-200'
        ),
        isDashed: isDashed,
      },
      props
    ),
    to
      ? /*#__PURE__*/ _react['default'].createElement(
          ButtonLink,
          {
            to: to,
            iconPosition: iconPosition,
            iconSpacing: iconSpacing,
          },
          Icon,
          /*#__PURE__*/ _react['default'].createElement(
            _styles.ButtonLabel,
            {
              as: 'label',
              fontWeight: '500',
              align: 'center',
            },
            children
          )
        )
      : /*#__PURE__*/ _react['default'].createElement(
          ButtonLoading,
          null,
          loading ? /*#__PURE__*/ _react['default'].createElement(_index.Spinner, null) : Icon,
          /*#__PURE__*/ _react['default'].createElement(
            _styles.ButtonLabel,
            {
              as: 'label',
              fontWeight: '500',
              align: 'center',
            },
            children
          )
        )
  )
}

exports.Button = Button

var ButtonLoading = _styledComponents['default'].div(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteral([
      '\n  display: flex;\n  align-items: center;\n  justify-content: center;\n',
    ]))
) // styled components passes down ALL props to dom, where the only solution
// for now is this ugly mess

var ButtonLink = (0, _styledComponents['default'])(function (_ref2) {
  var rest = _extends({}, _ref2)

  return /*#__PURE__*/ _react['default'].createElement(_reactRouterDom.Link, rest)
})(
  _templateObject2 ||
    (_templateObject2 = _taggedTemplateLiteral([
      '\n  padding: 0 !important;\n  display: flex;\n  align-items: center;\n  flex-direction: ',
      ';\n  justify-content: ',
      ';\n  width: 100%;\n  height: 100%;\n  color: inherit;\n  padding: ',
      ';\n  &:hover {\n    color: inherit;\n  }\n\n  label {\n    padding-left: ',
      ';\n    padding-right: ',
      ';\n  }\n',
    ])),
  function (props) {
    return props.iconPosition === 'right' ? 'row-reverse' : 'row'
  },
  function (props) {
    return props.iconSpacing === 'space-between' ? 'space-between' : 'center'
  },
  function (props) {
    return props.padding ? props.theme.spacingToPx(props.padding) : props.theme.spacing(1.5)
  },
  function (props) {
    return props.iconPosition === 'left' ? props.theme.spacing(1.5) : 0
  },
  function (props) {
    return props.iconPosition === 'right' ? props.theme.spacing(1.5) : 0
  }
)
